export const getWindow = () => window

export const getLocationPathname = () => getWindow().location.pathname

export const reloadPage = () => window.location.reload()
